/**
 * Form plumbing for the export passphrase, kept out of the component file so
 * the component module exports only components (fast refresh) and so the
 * naming convention holds (camelCase for non-component TS).
 */
import { useForm } from '@tanstack/react-form';
import { MIN_TRANSFER_PASSPHRASE_LENGTH } from '../../../types/connectionTransfer';

export interface PassphraseFormValues {
  passphrase: string;
  confirm: string;
}

export function useExportPassphraseForm() {
  return useForm({ defaultValues: { passphrase: '', confirm: '' } as PassphraseFormValues });
}

/**
 * The passphrase to seal with, or `null` when the pair is not yet usable.
 * A single source of truth for both the button's disabled state and the value
 * that is sent, so the two cannot disagree.
 */
export function derivePassphrase(values: PassphraseFormValues): string | null {
  const { passphrase, confirm } = values;
  if (passphrase.length < MIN_TRANSFER_PASSPHRASE_LENGTH) return null;
  return passphrase === confirm ? passphrase : null;
}

export type ExportPassphraseFormApi = ReturnType<typeof useExportPassphraseForm>;
